import { forwardRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

interface IValidatorComponentProps {
  className?: string
  messageClassName?: string
  message?: string
  isShowRedBorder?: boolean
  children?: any
  messageEror?: string
}

interface IValidatorComponentHandle {
  onValidateMessage: (mess: string) => void
}

const Validator = forwardRef<
  IValidatorComponentHandle,
  IValidatorComponentProps
>((props, ref) => {
  const { t } = useTranslation()
  const {
    className,
    messageClassName,
    isShowRedBorder,
    children,
    messageEror,
  } = props
  const [message, setMessage] = useState('')

  useImperativeHandle(ref, () => ({
    onValidateMessage: (mess: string) => {
      setMessage(mess)
    },
  }))

  return (
    <>
      <div
        className={
          message && isShowRedBorder
            ? classNames('components__validator-input', className)
            : className
        }
      >
        {children}
      </div>

      {(message || messageEror) && (
        <div
          className={`bases__margin--top4 bases__text--red bases__font--14 ${messageClassName}`}
        >
          {t<string>(message) || messageEror}
        </div>
      )}
    </>
  )
})

Validator.defaultProps = {
  className: '',
  messageClassName: '',
  message: '',
  isShowRedBorder: true,
}

export default Validator
